<div class="container-fluid" style="padding:0px">
    <div class="alert alert-danger" role="alert" *ngIf="displayFailure"
        style="position:fixed; bottom:10pt; width:80%; margin-left:10%">
        <h5 class="H5Normal" style="display:inline">{{this.failureMessage}}</h5>
        <h5 class="H5Normal" style="cursor:pointer;display:inline;float:right;" (click)="HideFailureNotice()">X</h5>
    </div>
    <div (mouseenter)="this.dotComService.DisplaySubMenu('')">
        <div class="row mt-5 mb-5 whiteBackground" style="margin:auto; width:80%; max-width:1500px">
            <div class="col-lg-4">
                <div class="row mt-3 mb-3 blackText DIN2014Regular"
                    [ngClass]="{'blueText': calcType === 'spreader', 'blackText' : calcType != 'spreader'}"
                    style="font-size:26px; font-weight: 700; border-bottom: 1px solid grey;margin-right: 50px"
                    (click)="DisplaySpreaderCalculator()">
                    Spreader Calculator
                </div>
                <div class="row mt-3 mb-3 blackText DIN2014Regular"
                    [ngClass]="{'blueText': calcType === 'foliar', 'blackText' : calcType != 'foliar'}"
                    style="font-size:26px; font-weight: 700; border-bottom: 1px solid grey;margin-right: 50px"
                    (click)="DisplayFoliarCalculator()">
                    Foliar Calculator
                </div>
                <div class="row mt-3 mb-3 blackText DIN2014Regular"
                    [ngClass]="{'blueText': calcType === 'conversion', 'blackText' : calcType != 'conversion'}"
                    style="font-size:26px; font-weight: 700; border-bottom: 1px solid grey;margin-right: 50px"
                    (click)="DisplayConversionCalculator()">
                    Conversion Calculator
                </div>

            </div>
            <div class="col-lg-8 calcInputsOuter">
                <div *ngIf="calcType === 'spreader'">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row mt-3">
                                <h3 class="Caecilia76BoldItalic greenText"
                                    style="font-size: 36px; font-weight: 700; letter-spacing: -.72px;">Spreader
                                    Calculator
                                </h3>
                            </div>
                            <div class="row mt-3">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Particle
                                    Size</h6>
                                <select
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px; height:50px; padding-left:0px; margin-left:10px;"
                                    (change)="ParticleSizeChanged()" [(ngModel)]="this.particleSizeId">
                                    <!-- <option value="" disabled selected>Select A Size</option> -->
                                    <option *ngFor="let particleSize of this.particleSizes" class="DIN2014Regular"
                                        value={{particleSize.Id}}>
                                        {{particleSize.Size}}</option>
                                </select>
                            </div>
                            <div class="row mt-3">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Spreader
                                </h6>
                                <select
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px; height:50px; padding-left:0px; margin-left:10px;"
                                    (change)="SpreaderChanged()" [(ngModel)]="this.spreaderId">
                                    <option *ngFor="let spreader of this.spreaders" class="DIN2014Regular"
                                        value={{spreader.Id}}>
                                        {{spreader.Name}}</option>
                                </select>
                            </div>
                            <div class="row mt-3" *ngIf="showSpeed">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Speed
                                </h6>
                                <select class="DIN2014Regular"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px; height:50px; padding-left:0px; margin-left:10px;"
                                    [(ngModel)]="this.speed">
                                    <option *ngFor="let speed of this.speeds" class="DIN2014Regular" value={{speed.Id}}>
                                        {{speed.Speed}}</option>
                                </select>
                            </div>
                            <div class="row mt-3">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Product
                                    Density lbs/ft<sup>3</sup></h6>
                                <input Class="DIN2014Regular" (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px"
                                    [(ngModel)]="productDensity">
                            </div>
                            <div class="row mt-3">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Pounds
                                    Of
                                </h6>
                                <select class="DIN2014Regular"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px; height:50px; padding-left:0px; margin-left:10px;"
                                    [(ngModel)]="this.element">
                                    <option *ngFor="let element of this.elements" class="DIN2014Regular"
                                        value={{element.Id}}>
                                        {{element.Name}}</option>
                                </select>
                            </div>
                            <div class="row mt-3" *ngIf="this.element == 'P'">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Pounds
                                    of
                                    Product Per 1000 ft<sup>2</sup></h6>
                                <input Class="DIN2014Regular" (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px"
                                    [(ngModel)]="productPerThousand">
                            </div>

                            <div class="row mt-3" *ngIf="this.element == 'N'">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Nitrogen %
                                    of Product</h6>
                                <input Class="DIN2014Regular" (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px"
                                    [(ngModel)]="nitrogenPercent">
                            </div>

                            <div class="row mt-3" *ngIf="this.element == 'N'">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Pounds
                                    of
                                    Nitrogen Per 1000 ft<sup>2</sup></h6>
                                <input Class="DIN2014Regular" (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px"
                                    [(ngModel)]="nitrogenPerThousand">
                            </div>

                            <div class="row mt-3" *ngIf="this.element == 'K'">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Potassium %
                                    of Product</h6>
                                <input Class="DIN2014Regular" (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px"
                                    [(ngModel)]="potassiumPercent">
                            </div>
                            <div class="row mt-3" *ngIf="this.element == 'K'">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Pounds
                                    of
                                    Potassium Per 1000 ft<sup>2</sup></h6>
                                <input Class="DIN2014Regular" (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px"
                                    [(ngModel)]="potassiumPerThousand">
                            </div>
                            <div class="row mt-3 mb-5 text-center">
                                <a class="DIN2014Bold greenBackground whiteText"
                                    style="margin-left:10px; width:350px; font-size:20px; font-weight:700; padding:12px; text-decoration: none !important"
                                    (click)="Calculate()">CALCULATE</a>
                            </div>
                        </div>
                        <div class="col-lg">
                            <div class="text-center" style="margin-top:20%">
                                <h3 class="blackText DIN2014Regular"
                                    style="font-size: 36px; font-weight: 400; letter-spacing: -.72px;">Setting:
                                    {{this.setting}}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <h6 class="DIN2014Regular blackText"
                            style="font-size:19px; line-height:30px; font-weight: 400; letter-spacing: .38px;">This
                            spreader settings calculator should be used only for initial spreader settings. You may need
                            to adjust the setting calculated below depending on walking speed, spreader condition, and
                            specific product. Harrell's recommends you calibrate your spreader on a regular basis.</h6>
                    </div>
                    <div class="row mb-5">
                        <h6 class="DIN2014Regular blackText"
                            style="font-size:19px; line-height:30px; font-weight: 400; letter-spacing: .38px;">NOTE: For
                            walk-behind spreaders, calculations are based on a fixed walking speed of 4 mph.</h6>
                    </div>
                </div>
                <div *ngIf="calcType === 'foliar'">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row mt-3">
                                <h3 class="Caecilia76BoldItalic greenText"
                                    style="font-size: 36px; font-weight: 700; letter-spacing: -.72px;">Foliar Calculator
                                </h3>
                            </div>
                            <div class="row mt-3">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Product</h6>
                                <select
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px; height:50px; padding-left:0px; margin-left:10px;"
                                    [(ngModel)]="this.foliarItemNmbr">
                                    <option *ngFor="let item of this.foliarItems" class="DIN2014Regular"
                                        value={{item.ItemNmbr}}>
                                        {{item.WebName}}</option>
                                </select>
                            </div>
                            <div class="row mt-3">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Acres/Tank</h6>
                                <input Class="DIN2014Regular" (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px"
                                    [(ngModel)]="acresPerTank">
                            </div>
                            <div class="row mt-3">
                                <h6 class="DIN2014Regular"
                                    style="font-size: 19px; line-height: 20px; font-weight: 400; letter-spacing: .38px;">
                                    Jugs/Tank</h6>
                                <input Class="DIN2014Regular" (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px"
                                    [(ngModel)]="jugsPerTank">
                            </div>
                            <div class="row mt-3 mb-5 text-center">
                                <a class="DIN2014Bold greenBackground whiteText"
                                    style="margin-left:10px; width:350px; font-size:20px; font-weight:700; padding:12px; text-decoration: none !important"
                                    (click)="Calculate()">CALCULATE</a>
                            </div>
                        </div>
                        <div class="col-lg">
                            <div class="text-center" style="margin-top:20%">
                                <h3 class="blackText DIN2014Regular"
                                    style="font-size: 36px; font-weight: 400; letter-spacing: -.72px;">Results:</h3>
                                <div class="row" *ngFor="let result of this.foliarResults">
                                    <div class="col-3"></div>
                                    <div class="col-3">
                                        <h5>{{result.Element}}</h5>
                                    </div>
                                    <div class="col-3">
                                        <h5>{{result.ElementValue}}</h5>
                                    </div>
                                    <div class="col-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3 mb-5">
                        <h6 class="DIN2014Regular blackText"
                            style="font-size:19px; line-height:30px; font-weight: 400; letter-spacing: .38px;">This
                            foliar calculator should be used only for estimation purposes. You may need to adjust the
                            values calculated below depending on your particular conditions.</h6>
                    </div>
                </div>
                <div *ngIf="calcType === 'conversion'">
                    <div class="row mt-3">
                        <h3 class="Caecilia76BoldItalic greenText"
                            style="font-size: 36px; font-weight: 700; letter-spacing: -.72px;">Conversion Calculator
                        </h3>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-lg-3">
                            <div class="row">
                                <h5 class="control-label" style="margin-bottom:0px">From</h5>
                            </div>
                            <div class="row">
                                <input id="fromInput" [(ngModel)]="fromInput"
                                    (input)="dotComService.onlyOnePeriod($event)"
                                    (keypress)="dotComService.mustBeDigitAllowPeriods($event)" (keyup)="CalcResult()"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px;height:50px;margin-left:10px" />
                            </div>
                            <div class="row">
                                <input type="number" [(ngModel)]="toResult" id="toInput"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;height:50px;margin-left:10px"
                                    disabled />
                            </div>

                        </div>
                        <div class="col-lg-2" style="margin-right: 5px">
                            <div class="row">
                                <h5 class="control-label" style="margin-bottom:0px">To</h5>
                            </div>
                            <div class="row">
                                <select id="fromUOMDD" (change)="FromUOMDDChanged($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;height:50px; padding-left:0px; margin-left:10px; min-width: 250px;">
                                    <option class="other" value="">Choose Units</option>
                                    <optgroup label="Length">
                                        <option class="length" value="inches">Inches</option>
                                        <option class="length" value="feet">Feet</option>
                                        <option class="length" value="yards">Yards</option>
                                        <option class="length" value="miles">Miles</option>
                                        <option class="length" value="centimeters">Centimeters</option>
                                        <option class="length" value="meters">Meters</option>
                                        <option class="length" value="kilometers">Kilometers</option>
                                    </optgroup>
                                    <optgroup label="Area">
                                        <option class="area" value="acres">Acres</option>
                                        <option class="area" value="squaremiles">Square Miles</option>
                                        <option class="area" value="squarekilometers">Square Kilometers</option>
                                    </optgroup>
                                    <optgroup label="Temperature">
                                        <option class="temperature" value="farenheit">Farenheit</option>
                                        <option class="temperature" value="celsius">Celsius</option>
                                    </optgroup>
                                    <optgroup label="Volume">
                                        <option class="volume" value="fluidounces">Fluid Ounces</option>
                                        <option class="volume" value="quarts">Quarts</option>
                                        <option class="volume" value="gallons">Gallons</option>
                                    </optgroup>
                                    <optgroup label="Weight/Mass">
                                        <option class="weight" value="ounces">Ounces</option>
                                        <option class="weight" value="pounds">Pounds</option>
                                        <option class="weight" value="grams">Grams</option>
                                        <option class="weight" value="kilograms">Kilograms</option>
                                    </optgroup>
                                    <optgroup label="Application Rate">
                                        <option class="pressure" value="poundsper1000ft²">Pounds Per 1000 ft²
                                        </option>
                                        <option class="pressure" value="poundsperacre">Pounds Per Acre</option>
                                    </optgroup>
                                </select>
                            </div>
                            <div class="row">
                                <select id="toUOMDD" (change)="ToUOMDDChanged($event)"
                                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; height:50px; padding-left:0px; margin-left:10px;min-width:250px">
                                    <option *ngFor="let item of this.toOptions" class="DIN2014Regular"
                                        value={{item.value}}>
                                        {{item.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5 mb-5">
                        <h6 class="DIN2014Regular blackText"
                            style="font-size:19px; line-height:30px; font-weight: 400; letter-spacing: .38px;">Use the
                            unit converter above or download the <a class="blueText" target="_blank"
                                href="{{baseFilesPath + 'conversions.pdf'}}">Conversions Brochure (PDF)</a> which
                            includes metric, cubic measures, volumes and linear unit conversions.</h6>
                    </div>
                </div>
            </div>
        </div>

        <div class="lightCremeBackground">
            <div class="row lightCremeBackground yourPartnerForSuccess" id="partnersSuccessBlock">
                <div class="col-lg-4 greenText lightCremeBackground" style="padding-right:0px; padding-left:0px">
                    <h3 class="Caecilia76BoldItalic yourPartnerForSuccessDetail">
                        Harrell's Is Your<br />Partner For Success</h3>
                </div>
                <div class="col-lg-8">
                    <div class="row lightCremeBackground" style="padding-right:10%;">
                        <div class="col-lg-4 blueText text-center yourPartnerForSuccessBorder">
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-1.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    PH.D'S INNOVATING
                                    <br>
                                    PRODUCTS AND
                                    <br>
                                    PROGRAMS
                                </h4>
                            </div>
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-4.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    INVENTORY ENSURING <BR> PRODUCTS STAY <BR> STOCKED
                                </h4>
                            </div>
                        </div>
                        <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-2.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    REPS WITH <BR> FIRST-HAND FIELD <BR> EXPERIENCE
                                </h4>
                            </div>
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-5.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    OPS & DRIVERS <BR> DELIVERING THE <BR> GOODS
                                </h4>
                            </div>
                        </div>
                        <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-3.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    IT PROVIDING <BR> PROPRIETARY <BR> TECH
                                </h4>
                            </div>
                            <div class="margin:10px;">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-6.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    CORPORATE TEAMS <BR> SUPPORTING <BR> IT ALL
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="lightCremeBackground">
            <div class="row pt-3" style="margin:auto; width:80%; max-width:1500px">
                <div class="col-lg-4 greenText " style="padding-right:0px; padding-left:0px; padding-top:5%">
                    <h3 class="Caecilia76BoldItalic"
                        style="text-align: right; margin-right:5%; font-size:28px; line-height: 36px;">
                        Harrell's Is Your<br />Partner For Success</h3>
                </div>
                <div class="col-lg-8">
                    <div class="row lightCremeBackground" style="padding-right:10%;">
                        <div class="col-lg-4 blueText text-center pt-5 pb-5">
                            <div style="border-left:solid 1px grey">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-1.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    PH.D'S INNOVATING
                                    <br>
                                    PRODUCTS AND
                                    <br>
                                    PROGRAMS
                                </h4>
                            </div>
                            <div style="border-left:solid 1px grey">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-4.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    INVENTORY ENSURING <BR> PRODUCTS STAY <BR> STOCKED
                                </h4>
                            </div>
                        </div>
                        <div class="col-lg-4 blueText text-center pt-5 pb-5">
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-2.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    REPS WITH <BR> FIRST-HAND FIELD <BR> EXPERIENCE
                                </h4>
                            </div>
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-5.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    OPS & DRIVERS <BR> DELIVERING THE <BR> GOODS
                                </h4>
                            </div>
                        </div>
                        <div class="col-lg-4 blueText text-center pt-5 pb-5">
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-3.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    IT PROVIDING <BR> PROPRIETARY <BR> TECH
                                </h4>
                            </div>
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-6.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    CORPORATE TEAMS <BR> SUPPORTING <BR> IT ALL
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    <div *ngIf="!this.myHarrellsService.onlineOrderingInEffect && !(this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
        <div class="row">
            <div class="col-9 blueBackground whiteText" style="padding-top:5%">
                <h4 class="DIN2014Bold" style="text-align: LEFT; margin-left:20%; font-size:36px; line-height: 46px;">
                    Don't grow it alone. Connect with Harrell's to harness the power of research, science, and
                    support in
                    ways you never thought possible.</h4>
            </div>
            <div class="col-3 blueBackground whiteText" style="padding-top:3%">
            </div>
        </div>
        <div class="row blueBackground" style="padding-bottom:5%">
            <div class="col-xs-12 col-md-9" style="padding-top:3%">
                <h3 style="margin-left:20%"><a class="DIN2014Bold whiteBackground greenText"
                        style="font-size:20PX ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT
                        WITH
                        YOUR REP</a>
                </h3>
            </div>
        </div>
    </div>